"use client";

import type { StaticImageData } from "next/image";
import { PhotoView } from "react-photo-view";

type UserGuideImageProps = {
    image: StaticImageData;
    className?: string;
};

export default function UserGuideImage({
    image,
    className = "h-auto w-full",
}: UserGuideImageProps) {
    return (
        <PhotoView src={image.src}>
            <img
                src={image.src}
                alt=""
                width={image.width}
                height={image.height}
                className={`cursor-zoom-in ${className}`}
            />
        </PhotoView>
    );
}
